"use client";

import type { FC } from "react";
import { useCarousel } from "../carousel";
import useSelectedIndex from "./hooks/useSelectedIndex";

type Props = {
  count: number;
  label: string;
};

const PromoCarouselDots: FC<Props> = ({ count, label }) => {
  const { api } = useCarousel();
  const selectedIndex = useSelectedIndex(api);

  if (count <= 1 || (api && api.scrollSnapList().length <= 1)) {
    return null;
  }

  return (
    <div
      data-slot="promo-carousel-dots"
      className="mt-2 flex h-3.5 items-center justify-center gap-3 [@media(hover:hover)]:@min-[960px]:hidden!"
    >
      {Array.from({ length: count }, (_, index) => (
        <button
          key={index}
          type="button"
          data-slot="promo-carousel-dot"
          aria-label={`${label} ${index + 1}`}
          aria-current={index === selectedIndex}
          onClick={() => api?.scrollTo(index)}
          className="relative size-1.5 cursor-pointer rounded-full bg-foreground/25 outline-none transition-colors before:absolute before:-inset-2 focus-visible:ring-3 focus-visible:ring-ring/50 aria-current:bg-primary"
        />
      ))}
    </div>
  );
};

export default PromoCarouselDots;
